module.exports = __webpack_public_path__ + "img/block32.3bcab614.jpg";